import lpz from "../../images/productsImages/hydroneumaticImages/LPZ.jpg";
import ljp from "../../images/productsImages/hydroneumaticImages/SERIELJP.jpg";
import pg from "../../images/productsImages/hydroneumaticImages/SERIEPG.jpg";
import chl from "../../images/productsImages/hydroneumaticImages/chlhidro.jpg";
import chj from "../../images/productsImages/hydroneumaticImages/chjhidro.jpg";
import ydq from "../../images/productsImages/hydroneumaticImages/YDQserie.jpg";
import ydjs from "../../images/productsImages/hydroneumaticImages/YDJSPserie.jpg";

import pdf1 from "../../pdf/hydroneumatic/Serie-LPZ.pdf";
import pdf2 from "../../pdf/hydroneumatic/Serie-LJP.pdf";
import pdf3 from "../../pdf/hydroneumatic/Serie-PG.pdf";
import pdf4 from "../../pdf/hydroneumatic/BGP-CHLSeries.pdf";
import pdf5 from "../../pdf/hydroneumatic/BGP-CHJSeries.pdf";
import pdf6 from "../../pdf/hydroneumatic/KIT HIDRONEUMATICOSYDQ.pdf";
import pdf7 from "../../pdf/hydroneumatic/KITHIDRONEUMATICOSYDjsp.pdf";

const hydroneumaticList = [
  {
    _id: "hyd001",
    image: lpz,
    title: "Sistema hidroneumático serie LPZ",
    code: "",
    category: "Little Giant",
    brand: "Little Giant",
    downLoad: pdf1,
  },
  {
    _id: "hyd002",
    image: ljp,
    title: "Sistema hidroneumático serie LJP",
    code: "",
    category: "Little Giant",
    brand: "Little Giant",
    downLoad: pdf2,
  },
  {
    _id: "hyd003",
    image: pg,
    title: "Sistema hidroneumático serie PG",
    code: "",
    category: "Little Giant",
    brand: "Little Giant",
    downLoad: pdf3,
  },
  {
    _id: "hyd004",
    image: chl,
    title: "Sistema hidroneumático serie CHL",
    code: "",
    category: "BGP",
    brand: "BGP",
    downLoad: pdf4,
  },
  {
    _id: "hyd005",
    image: chj,
    title: "Sistema hidroneumático serie CHJ",
    code: "",
    category: "BGP",
    brand: "BGP",
    downLoad: pdf5,
  },
  {
    _id: "hyd006",
    image: ydq,
    title: "Sistema hidroneumático serie YDQ",
    code: "",
    category: "Speroni",
    brand: "Speroni",
    downLoad: pdf6,
  },
  {
    _id: "hyd007",
    image: ydjs,
    title: "Sistema hidroneumático serie YDJSP",
    code: "",
    category: "Speroni",
    brand: "Speroni",
    downLoad: pdf7,
  },
];

export default hydroneumaticList;
